/**
 * Los cuatro tipos de dependencia, en un solo lugar.
 *
 * De que punta de la predecesora sale el vinculo y a que punta de la sucesora llega. Es lo que
 * decide como se dibuja la flecha en el Gantt **y** lo que dice el selector del tablero, asi que
 * vive aca y no en ninguno de los dos: dos tablas con las mismas siglas se separan en silencio, y
 * el dia que se separen una pantalla va a decir "CC" de lo que la otra dibuja como fin a comienzo.
 *
 * Los ids largos son los que estan guardados en Mongo (`services/schedule_links.py:LINK_TYPES`) y
 * no se abrevian. Las siglas son de la disciplina, en castellano: **C**omienzo y **F**in.
 */
export const TIPOS_DE_VINCULO = {
  finish_to_start: {
    de: 'fin', a: 'inicio', sigla: 'FC',
    label: 'Fin → Comienzo (arranca cuando la otra termina)',
  },
  start_to_start: {
    de: 'inicio', a: 'inicio', sigla: 'CC',
    label: 'Comienzo → Comienzo (arrancan juntas)',
  },
  finish_to_finish: {
    de: 'fin', a: 'fin', sigla: 'FF',
    label: 'Fin → Fin (terminan juntas)',
  },
  start_to_finish: {
    de: 'inicio', a: 'fin', sigla: 'CF',
    label: 'Comienzo → Fin (termina cuando la otra arranca)',
  },
};

/** El que se asume cuando nadie eligio, igual que el default del backend. */
export const TIPO_POR_OMISION = 'finish_to_start';
